export const CUSTOM_PLCCODE = '0';

